import { render } from "./WithdrawLogsEdit.vue?vue&type=template&id=579b64a2"
import script from "./WithdrawLogsEdit.vue?vue&type=script&lang=js"
export * from "./WithdrawLogsEdit.vue?vue&type=script&lang=js"

import "./WithdrawLogsEdit.vue?vue&type=style&index=0&id=579b64a2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__